<template>
    <component :is="layout">
        <slot />
    </component>
</template>

<script>
import { markRaw } from "@vue/reactivity";
import AppLayoutBlank from "@/layouts/AppLayoutBlank";
import AppInitLayout from "@/layouts/AppInitLayout.vue"; //Init layout for layout reactive (and to avoid calling things twice)
export default {
    name: "AppLayout",
    data: () => ({
        layout: markRaw(AppInitLayout),
    }),
    watch: {
        $route: {
            immediate: true,
            async handler(route) {
                try {
                    // Only re-render the layout if it's different from the current one
                    if (this.layout.name != route.meta.layout) {
                        const component = await import(`@/layouts/${route.meta.layout}.vue`);
                        this.layout = markRaw(component?.default || AppLayoutBlank);
                    }
                } catch (e) {
                    this.layout = AppLayoutBlank;
                }
            },
        },
    },
};
</script>
